import { render, staticRenderFns } from "./newMarketingActivity.vue?vue&type=template&id=99071b1e&scoped=true&"
import script from "./newMarketingActivity.vue?vue&type=script&lang=js&"
export * from "./newMarketingActivity.vue?vue&type=script&lang=js&"
import style0 from "./newMarketingActivity.vue?vue&type=style&index=0&id=99071b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99071b1e",
  null
  
)

export default component.exports